query canOverwriteEditables($campaignId: ID!, $editableGroupValueIds: [ID]!) {
    canOverwriteEditables(campaignId: $campaignId, editableGroupValueIds: $editableGroupValueIds)
}
